/*
 * Copyright (C) 2018-2019 Nettoken Ltd. All rights reserved.
 *
 * This document is the property of Nettoken Ltd.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Nettoken Ltd.
 */
class KeyPair {
  constructor() {
    this.publicKey = null;
    this.secretKey = null;
  }

  /**
   * Both keys must be set before this key pair can be used.
   */
  defined() {
    return Boolean(this.publicKey && this.secretKey);
  }

  /**
   * @param {UInt8Array} publicKey 32-bytes long array.
   * @param {UInt8Array} secretKey 32-bytes long array.
   */
  set(publicKey, secretKey) {
    this.publicKey = publicKey;
    this.secretKey = secretKey;
  }

  /**
   * Resets both keys.
   */
  unset() {
    this.publicKey = null;
    this.secretKey = null;
  }
}

export default KeyPair;
